import * as React from "react";
import FormControl from "@mui/material/FormControl";
import InputAdornment from "@mui/material/InputAdornment";
import {MenuItem, Select} from "@mui/material";
import {SearchData} from "@/widget/SearchData/SearchData";
import {useForm, useWatch} from "react-hook-form";
import * as z from "zod";
import {useGlobalActions} from "@/store/global.c";
import {ViewCustomer} from "@/pages/Customer/ViewCustomer";
import {ViewChance} from "@/pages/Chance/ViewChance";
import {ViewContract} from "@/pages/Contract/ViewContract";
import {find} from "lodash";
import {useMemo} from "react";
import {ViewPatent} from "@/pages/Patent/ViewPatent";
import {ViewContact} from "@/pages/Contact/ViewContact";
import {ViewProject} from "@/pages/Project/ViewProject";
import {ViewPayback} from "@/pages/Payback/ViewPayback";

const validationSchema = z.object({
    tag: z.number().default(1),
    searchId: z.number().default(0),
    searchName: z.string().optional(),
})

type GlobalSearchType = {
    value: number
    label: string
    keyword: string
    body: React.ReactNode
}

const selectTags: GlobalSearchType[] = [{
    value: 1, label: "客户", keyword: "客户名称、联系人、电话...", body: <ViewCustomer mode={'drawer'}/>
},
    {value: 3, label: "商机", keyword: "服务名称、商机阶段...", body: <ViewChance mode={'drawer'}/>},
    {value: 2, label: "合同", keyword: "合同名称、合同编号...", body: <ViewContract mode={'drawer'}/>},
    {value: 12, label: "已收款", keyword: "客户名称、业务内容...", body: <ViewPayback flag={1} mode={'drawer'}/>},
    {value: 11, label: "项目", keyword: "政策项目名称、客户名称...", body: <ViewProject/>},
    {value: 8, label: "专利", keyword: "专利名称、专利号、客户名称...", body: <ViewPatent/>},
    {value: 10, label: "联系人", keyword: "姓名、电话、邮箱...", body: <ViewContact/>},
]

export type GlobalSearchForm = z.infer<typeof validationSchema>

export default function SearchBar() {
    const {
        register,
        control,
    } = useForm<GlobalSearchForm>({defaultValues: {tag: 1}});
    const {setDrawerModal} = useGlobalActions()
    const tag: number = useWatch({
        control,
        name: "tag",
        defaultValue: 1
    })

    const selectTag = useMemo(() => {
        const selectTag = find(selectTags, (item: GlobalSearchType) => item.value == tag)
        return selectTag
    }, [tag]);

    const onSelect = (item: any) => {
        if (item) {
            setDrawerModal({id: item.id, body: selectTag?.body, hiddenFooter: true, open: true, header: `查看${selectTag?.label}`})
        }
    }

    return (
        <FormControl sx={{width: {xs: "100%", sm: "26ch", md: "30ch", lg: "34ch"},}} variant="outlined">
            <SearchData<GlobalSearchForm, any> control={control} label={''}
                                               tag={tag}
                                               onSelect={onSelect}
                                               placeholder={selectTag?.keyword}
                                               attr={"searchName"}
                                               startNode={<InputAdornment position="start">
                                                   <FormControl defaultValue={tag} variant="standard" sx={{my: 1, width: 60}}>
                                                       <Select
                                                           displayEmpty
                                                           defaultValue={tag}
                                                           value={tag}
                                                           {...register('tag')}
                                                           sx={{boxShadow: 'none', backgroundColor: 'transparent', border: 'none', marginRight: 0}}>
                                                           {selectTags?.map(item => <MenuItem value={item.value}>{item.label}</MenuItem>)}
                                                       </Select>
                                                   </FormControl>
                                               </InputAdornment>}
                                               attrId={"searchId"}/>
        </FormControl>

    );
}
